/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_2_AnswerInputs */

const en_gc_search_guides_what_is_gridcraft_sections_8_questions_2_answer = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workbook is the file you open and save. It can contain several worksheets, each represented by a sheet tab. When checking an imported file, inspect more than the first worksheet: other sheets may contain inputs, lookup data or formulas that the visible summary depends on.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_8_questions_2_answer = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_2_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作簿是你打开和保存的文件，其中可以包含多个工作表，每个工作表对应一个标签。检查导入文件时，不要只看第一个工作表；其他标签中可能存放汇总所依赖的输入、查找数据或公式。`)
};

/**
* | output |
* | --- |
* | "A workbook is the file you open and save. It can contain several worksheets, each represented by a sheet tab. When checking an imported file, inspect more th..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_2_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_8_questions_2_answer = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_2_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_2_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_8_questions_2_answer(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_8_questions_2_answer(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_8_questions_2_answer as "gc.search_guides.what_is_gridcraft.sections.8.questions.2.answer" }